/* ================================================================
   SHOPIFY AJAX CART — uses the store's real cart via /cart/*.js
   ================================================================ */
let cartBusy = false;

function fmtMoney(cents) {
  return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

async function getCart() {
  const res = await fetch('/cart.js');
  return res.json();
}

async function addToCart(variantId, quantity = 1) {
  if (cartBusy) return;
  cartBusy = true;
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
    });
    if (!res.ok) {
      const err = await res.json();
      throw new Error(err.description || 'Could not add to cart');
    }
    const cart = await getCart();
    renderCart(cart);
    openCart();
    bumpCartIcon();
  } catch (err) {
    console.error(err);
    renderCartError('Could not add to cart. It may be sold out.');
  } finally {
    cartBusy = false;
  }
}

async function changeLine(line, quantity) {
  if (cartBusy) return;
  cartBusy = true;
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity }),
    });
    const cart = await res.json();
    renderCart(cart);
  } catch (err) {
    console.error(err);
    renderCartError('Could not update cart.');
  } finally {
    cartBusy = false;
  }
}

function renderCartError(msg) {
  const list = document.getElementById('cartItemsList');
  if (list) {
    const p = document.createElement('p');
    p.className = 'shopify-error';
    p.textContent = msg;
    list.prepend(p);
  }
}

function renderCart(cart) {
  const countEl = document.getElementById('cartCount');
  const listEl = document.getElementById('cartItemsList');
  const subtotalEl = document.getElementById('cartSubtotal');
  const proceedBtn = document.getElementById('proceedBtn');
  if (!countEl || !listEl || !subtotalEl || !proceedBtn) return;

  countEl.textContent = cart.item_count;
  subtotalEl.textContent = fmtMoney(cart.total_price);
  proceedBtn.disabled = cart.item_count === 0;

  if (cart.item_count === 0) {
    listEl.innerHTML = '<p class="cart-empty">Nothing here yet.</p>';
    return;
  }

  listEl.innerHTML = cart.items.map((item, i) => `
    <div class="cart-item">
      <div class="swatch">${item.image ? `<img src="${item.image}" alt="${item.product_title}">` : ''}</div>
      <div class="cart-item-info">
        <div class="top">
          <span class="cart-item-name">${item.product_title}</span>
          <span class="cart-item-price">${fmtMoney(item.line_price)}</span>
        </div>
        <div class="qty-row">
          <button class="qty-btn" data-qty-down="${i + 1}" ${cartBusy ? 'disabled' : ''}>&minus;</button>
          <span>${item.quantity}</span>
          <button class="qty-btn" data-qty-up="${i + 1}" ${cartBusy ? 'disabled' : ''}>+</button>
          <button class="remove-btn" data-remove-line="${i + 1}">Remove</button>
        </div>
      </div>
    </div>
  `).join('');
}

function bumpCartIcon() {
  if (window.gsap) {
    gsap.fromTo('#cartCount', { scale: 1.7 }, { scale: 1, duration: 0.6, ease: 'elastic.out(1,0.5)' });
  }
}

/* ================================================================
   CART SIDEBAR open/close
   ================================================================ */
let cartOpen = false;
function openCart() {
  const sidebar = document.getElementById('cartSidebar');
  const overlay = document.getElementById('cartOverlay');
  if (!sidebar || !overlay) return;
  cartOpen = true;
  sidebar.setAttribute('aria-hidden', 'false');
  sidebar.classList.add('is-open');
  overlay.classList.add('is-open');
}
function closeCart() {
  const sidebar = document.getElementById('cartSidebar');
  const overlay = document.getElementById('cartOverlay');
  if (!sidebar || !overlay) return;
  cartOpen = false;
  sidebar.setAttribute('aria-hidden', 'true');
  sidebar.classList.remove('is-open');
  overlay.classList.remove('is-open');
}

document.addEventListener('DOMContentLoaded', () => {
  document.getElementById('cartOpenBtn')?.addEventListener('click', async () => {
    openCart();
    renderCart(await getCart());
  });
  document.getElementById('cartCloseBtn')?.addEventListener('click', closeCart);
  document.getElementById('cartOverlay')?.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && cartOpen) closeCart(); });

  document.getElementById('proceedBtn')?.addEventListener('click', () => {
    window.location.href = '/checkout';
  });

  // Intercept "add to cart" forms across the site (product cards + product page)
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('.ajax-cart-form');
    if (!form) return;
    e.preventDefault();
    const formData = new FormData(form);
    const variantId = formData.get('id');
    const quantity = Number(formData.get('quantity')) || 1;
    if (variantId) addToCart(variantId, quantity);
  });

  // Cart quantity +/- and remove, delegated from the sidebar
  document.addEventListener('click', (e) => {
    const up = e.target.closest('[data-qty-up]');
    if (up) {
      getCart().then(cart => {
        const line = Number(up.dataset.qtyUp);
        const item = cart.items[line - 1];
        if (item) changeLine(line, item.quantity + 1);
      });
      return;
    }
    const down = e.target.closest('[data-qty-down]');
    if (down) {
      getCart().then(cart => {
        const line = Number(down.dataset.qtyDown);
        const item = cart.items[line - 1];
        if (item) changeLine(line, Math.max(0, item.quantity - 1));
      });
      return;
    }
    const rem = e.target.closest('[data-remove-line]');
    if (rem) {
      changeLine(Number(rem.dataset.removeLine), 0);
      return;
    }
  });
});

/* ================================================================
   LENIS — smooth scroll
   ================================================================ */
let lenis = null;
if (window.Lenis) {
  lenis = new Lenis({
    duration: 0.9,
    easing: (t) => 1 - Math.pow(1 - t, 3),
    smoothWheel: true,
    wheelMultiplier: 1,
    touchMultiplier: 1.1,
  });
  window.lenis = lenis;
  if (window.gsap && window.ScrollTrigger) {
    gsap.registerPlugin(ScrollTrigger);
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add((time) => { lenis.raf(time * 1000); });
    gsap.ticker.lagSmoothing(0);
  }
}

/* ================================================================
   CUSTOM CURSOR — desktop only
   ================================================================ */
const isFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
if (isFinePointer && window.gsap) {
  const dot = document.getElementById('cursorDot');
  const ring = document.getElementById('cursorRing');
  if (dot && ring) {
    const dotX = gsap.quickTo(dot, 'x', { duration: 0.15, ease: 'power3.out' });
    const dotY = gsap.quickTo(dot, 'y', { duration: 0.15, ease: 'power3.out' });
    const ringX = gsap.quickTo(ring, 'x', { duration: 0.5, ease: 'power3.out' });
    const ringY = gsap.quickTo(ring, 'y', { duration: 0.5, ease: 'power3.out' });
    window.addEventListener('mousemove', e => {
      dotX(e.clientX); dotY(e.clientY);
      ringX(e.clientX); ringY(e.clientY);
    });
    document.querySelectorAll('a, button, .card').forEach(el => {
      el.addEventListener('mouseenter', () => gsap.to(ring, { scale: el.classList.contains('card') ? 1.8 : 1.6, duration: 0.5, ease: 'power3.out' }));
      el.addEventListener('mouseleave', () => gsap.to(ring, { scale: 1, duration: 0.5, ease: 'power3.out' }));
    });
    document.querySelectorAll('.magnetic').forEach(el => {
      const strength = 0.35;
      const moveX = gsap.quickTo(el, 'x', { duration: 0.5, ease: 'power3.out' });
      const moveY = gsap.quickTo(el, 'y', { duration: 0.5, ease: 'power3.out' });
      el.addEventListener('mousemove', e => {
        const r = el.getBoundingClientRect();
        moveX((e.clientX - r.left - r.width / 2) * strength);
        moveY((e.clientY - r.top - r.height / 2) * strength);
      });
      el.addEventListener('mouseleave', () => { moveX(0); moveY(0); });
    });
  }
}

/* ================================================================
   HERO TEXT ANIMATION
   ================================================================ */
function splitToSpans(el) {
  const text = el.textContent;
  el.innerHTML = [...text].map(ch => `<span>${ch === ' ' ? '&nbsp;' : ch}</span>`).join('');
  return el.querySelectorAll('span');
}

function playHeroIntro() {
  const heroTitleEl = document.getElementById('heroTitle');
  const mottoEl = document.getElementById('mottoText');
  const eyebrowEl = document.getElementById('eyebrowText');
  if (!heroTitleEl || !mottoEl || !window.gsap) return;

  const titleChars = splitToSpans(heroTitleEl);
  const mottoChars = splitToSpans(mottoEl);

  gsap.set(titleChars, { yPercent: 130 });
  gsap.set(mottoChars, { yPercent: 130, opacity: 0 });
  if (eyebrowEl) gsap.set(eyebrowEl, { yPercent: 130 });

  const tl = gsap.timeline({ delay: 0.3 });
  if (eyebrowEl) tl.to(eyebrowEl, { yPercent: 0, duration: 1.1, ease: 'power4.out' });
  tl.to(titleChars, { yPercent: 0, duration: 1.4, ease: 'power4.out', stagger: 0.05 }, '-=0.7')
    .to(mottoChars, { yPercent: 0, opacity: 1, duration: 1.1, ease: 'power3.out', stagger: 0.02 }, '-=0.8');
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', playHeroIntro);
} else {
  playHeroIntro();
}

document.addEventListener('DOMContentLoaded', () => {
  if (!window.gsap) return;
  gsap.utils.toArray('.card').forEach((card, i) => {
    gsap.fromTo(card, { opacity: 0, y: 40 }, {
      opacity: 1, y: 0, duration: 0.9, ease: 'power3.out', delay: (i % 3) * 0.06,
      scrollTrigger: { trigger: card, start: 'top 88%' },
    });
  });
  gsap.utils.toArray('.section-head').forEach(head => {
    gsap.from(head, { opacity: 0, y: 34, duration: 1.1, ease: 'power4.out', scrollTrigger: { trigger: head, start: 'top 85%' } });
  });
  gsap.from('.story-grid > *', {
    opacity: 0, y: 26, duration: 1.1, stagger: 0.18, ease: 'power4.out',
    scrollTrigger: { trigger: '.story-grid', start: 'top 80%' },
  });
  window.addEventListener('load', () => ScrollTrigger.refresh());
});
